import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

/**
 * `/patients/$patientId` — the record's address.
 *
 * The path segment is the document's string id, passed to the read untrimmed
 * (`features/patients/api/profile.ts`). `VIEW_PATIENT` gates it at the
 * parent. The record is this file's only import and this route's own chunk,
 * so a visit to `/patients` never downloads it.
 */
export const Route = createFileRoute("/_authenticated/patients/$patientId")({
  component: lazyRouteComponent(() => import("@/features/patients/patient-record"), "PatientRecord"),
});
